export default {
      id: "dots-whyus-3_color-usage",
      viewBox: "0 0 140 135",
      url: __webpack_public_path__ + "sprite.svg#dots-whyus-3_color",
      toString: function () {
        return this.url;
      }
    }